import script from "./ResultTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ResultTemplate.vue?vue&type=style&index=0&id=78a9a754&scoped=true&lang=scss"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a9a754"]])

export default __exports__